import { LeadPayments } from '@/api/types/crm.types'
import moment from 'moment'

export const formatPrice = (num: number): string => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

export const getLatestActivePayment = (
  payments: LeadPayments['directions'][number]['payments'],
) => {
  return payments
    .filter((p) => p.status !== 0)
    .reduce(
      (latest, current) =>
        moment(current.created_at).isAfter(moment(latest.created_at))
          ? current
          : latest,
      payments[0],
    )
}
